import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getEmployeeAuditReport } from '_services/employee-audit-report-service';

export const fetchEmployeeAuditReport = createAsyncThunk(
  'employeeAuditReport/fetch',
  async (params) => {
    const { geolocations, beaconEvents } = await getEmployeeAuditReport(params);
    return { geolocations, beaconEvents };
  }
);

const initialState = {
  data: null,
  status: 'idle',
  error: null,

  beaconData: null,
  beaconStatus: 'idle',
  beaconError: null,
};

const employeeAuditReportSlice = createSlice({
  name: 'employeeAuditReport',
  initialState,
  reducers: {
    resetEmployeeAuditReport: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
      state.beaconData = null;
      state.beaconStatus = 'idle';
      state.beaconError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeAuditReport.pending, (state) => {
        state.status = 'loading';
        state.beaconStatus = 'loading';
        state.error = null;
        state.beaconError = null;
      })
      .addCase(fetchEmployeeAuditReport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.beaconStatus = 'succeeded';
        state.data = action.payload.geolocations;
        state.beaconData = action.payload.beaconEvents;
        state.error = null;
        state.beaconError = null;
      })
      .addCase(fetchEmployeeAuditReport.rejected, (state, action) => {
        state.status = 'failed';
        state.beaconStatus = 'failed';
        state.error = action.error.message;
        state.beaconError = action.error.message;
      });
  },
});

// Geolocation selectors
export const selectEmployeeAuditReportData = (state) => state.employeeAuditReport.data;
export const selectEmployeeAuditReportCoordinates = (state) => {
  const data = state.employeeAuditReport.data;
  if (!data) return null;
  return data.map((doc) => ({
    latitude: doc.latitude,
    longitude: doc.longitude,
    timestamp: doc.timestamp,
  }));
};
export const selectEmployeeAuditReportStatus = (state) => state.employeeAuditReport.status;
export const selectEmployeeAuditReportError = (state) => state.employeeAuditReport.error;

// Beacon selectors
export const selectEmployeeAuditBeaconData = (state) => state.employeeAuditReport.beaconData;
export const selectEmployeeAuditBeaconCoordinates = (state) => {
  const data = state.employeeAuditReport.beaconData;
  if (!data) return null;
  return data.map((doc) => ({
    id: doc.id,
    major: doc.major,
    minor: doc.minor,
    timestamp: new Date(doc.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
  }));
};
export const selectEmployeeAuditBeaconStatus = (state) => state.employeeAuditReport.beaconStatus;
export const selectEmployeeAuditBeaconError = (state) => state.employeeAuditReport.beaconError;

export const { resetEmployeeAuditReport } = employeeAuditReportSlice.actions;

export default employeeAuditReportSlice.reducer;
